import { apiSlice } from "../apiSlice";

export const authApiSlice = apiSlice.injectEndpoints({
  overrideExisting: true,
  endpoints: (builder) => ({
    login: builder.mutation({
      query: (credentials) => ({
        url: "/loginCima",
        method: "POST",
        body: {
          USRIDXXX: credentials.name,
          USRPASXX: credentials.password,
          SISTEMAX: "CIMA",
        },
      }),
    }),
    logout: builder.mutation({
      query: () => ({
        url: "/logout",
        method: "GET",
      }),
    }),
    //Sondeo: pregunta si ya hay una sesion externa abierta. La pantalla de Login lo
    //llama ANTES de que nadie se haya autenticado, asi que el 401 es la respuesta
    //normal cuando no hay sesion, no una sesion vencida. Sin silent401 el baseQuery
    //lo tomaba como expiracion, cerraba sesion y sacaba el aviso rojo "Tu sesion en
    //CIMA ha expirado" encima del escritorio recien abierto (root/gestionsiaco#283).
    userInfo: builder.query({
      query: () => `/userinfo`,
      extraOptions: { silent401: true },
    }),
    loginUserExternal: builder.mutation({
      query: (params) => ({
        url: "/loginCima",
        method: "POST",
        body: {
          USRIDXXX: params.USRIDXXX,
          USRPASXX: params.USRIDXXX,
          SISTEMAX: "CIMA",
          EXTERNAL: true,
        },
      }),
    }),
    getPermissionUserReplace: builder.mutation({
      query: (parameters) => ({
        url: `/getPermissionUserReplace/${parameters.USRIDXXX}`,
        method: "GET",
        headers: { Modulecima: "usuarios" },
      }),
    }),
    getUserTemporal: builder.query({
      query: (parameters) => ({
        url: `/getUserTemporal/${parameters.USRIDXXX}`,
        method: "GET",
        headers: { Modulecima: "usuarios" },
      }),
    }),
    decryptUrl: builder.query({
      query: (parameters) => ({
        url: `/Decrypxx`,
        method: "GET",
        params: { query: parameters },
      }),
    }),
    getDashboard: builder.query({
      query: () => ({
        url: `/Usuarios/Dashboar`,
        method: "GET",
        headers: { Modulecima: "usuarios" },
      }),
    }),
    getTurnsTodayByUser: builder.query({
      query: ({ USRIDXXX }) => ({
        url: `/Usuarios/getTurnsTodayByUser/${USRIDXXX}`,
        method: "GET",
        headers: { Modulecima: "usuarios" },
      }),
    }),
    userAbsent: builder.mutation({
      query: ({ USRIDXXX, USREMAXX, JUSTIFIC, TIPAUSDE }) => ({
        url: `/userAbsent/${USRIDXXX}`,
        method: "POST",
        headers: { Modulecima: "usuarios" },
        body: { USRIDXXX, USREMAXX, JUSTIFIC, TIPAUSDE },
      }),
    }),
    getUserAusent: builder.mutation({
      query: (USRIDXXX) => ({
        url: `/Usuarios/getUserausent`,
        method: "GET",
        headers: { Modulecima: "usuarios" },
        params: { USRIDXXX },
      }),
    }),
    setUserAusent: builder.mutation({
      query: ({ USRIDXXX, TERMINATE = false }) => ({
        url: `/Usuarios/setUserAbsent/${USRIDXXX}`,
        method: "GET",
        headers: { Modulecima: "paramgen" },
        params: TERMINATE ? { TERMINATE: "TRUE" } : undefined,
      }),
    }),
    getTiposAusencias: builder.query({
      query: () => ({
        url: `/Usuarios/getTiposAusencias`,
        method: "GET",
        headers: { Modulecima: "usuarios" },
      }),
    }),
  }),
});

export const authApiTokenSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    loginToken: builder.mutation({
      query: (credentials) => ({
        url: "/loginCimaCode",
        method: "POST",
        body: {
          USRIDXXX: credentials.USRIDXXX,
          USRTOKXX: credentials.userCode,
          SISTEMAX: "CIMA",
        },
      }),
    }),
  }),
});


export const {
  useLoginMutation,
  useLogoutMutation,
  useUserInfoQuery,
  useLazyUserInfoQuery,
  useGetPermissionUserReplaceMutation,
  useGetUserTemporalQuery,
  useLoginUserExternalMutation,
  useDecryptUrlQuery,
  useGetDashboardQuery,
  useUserAbsentMutation,
  useGetTurnsTodayByUserQuery,
  useGetUserAusentMutation,
  useSetUserAusentMutation,
  useGetTiposAusenciasQuery,
} = authApiSlice;
export const { useLoginTokenMutation } = authApiTokenSlice;
